/*
Copyright 2022-2024 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC } from "react";
import { useLocation } from "react-router-dom";
import { Heading, Text } from "@vector-im/compound-web";
import { useTranslation } from "react-i18next";

import styles from "./RoomAuthView.module.css";
import { Header, HeaderLogo, LeftNav, RightNav } from "../Header";
import { UserMenuContainer } from "../UserMenuContainer";
import { LinkButton } from "../button/LinkButton";
import { useUrlParams } from "../UrlParams";

export const RoomAuthView: FC = () => {
  const { header } = useUrlParams();
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      {header === "standard" && (
        <Header>
          <LeftNav>
            <HeaderLogo />
          </LeftNav>
          <RightNav>
            <UserMenuContainer preventNavigation />
          </RightNav>
        </Header>
      )}
      <div className={styles.container}>
        <main className={styles.main}>
          <Heading size="xl" weight="semibold" className={styles.headline}>
            {t("login_title")}
          </Heading>
          <Text size="md" className={styles.message}>
            Login to join this scheduled meeting.
          </Text>
          <LinkButton to="/login" state={{ from: location }} size="lg">
            {t("login_title")}
          </LinkButton>
        </main>
      </div>
    </>
  );
};
